export const APP_NAME = 'Ecme'
export const REDIRECT_URL_KEY = 'redirectUrl'
export const CONSENT_REQUIRED_KEY = 'consentRequired'
export const CONSENT_ACCEPTED_COUNT_KEY = 'consentAcceptedCount'
export const CONSENT_TOTAL_KEY = 'consentTotalCount'
